import refs from 'bz-utilities/modules/legacy/refs';
import cx from 'classnames';
import createReactClass from 'create-react-class';
import React from 'react';
import ReactDOM from 'react-dom';
import PublishMixin from '../../../mixins/publish-mixin';
import PureRenderMixin from '../../../mixins/pure-render-mixin';

import { faStar } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Input, InputAdornment } from '@material-ui/core';
import { TextField } from '@zinc/ui';

const StarInput = createReactClass({
  displayName: 'star-input',
  mixins: [PublishMixin, PureRenderMixin],

  getDefaultProps() {
    return {
      value: '',
      onStarChange() {}
    };
  },

  onChange(e) {
    const input = e.target.value;
    if (input[input.length - 1] === ' ') {
      e.target.value = input.substring(0, input.length - 1);
    }
    const text = this.get('value');
    let prefix = '';
    if ((text != null ? text.indexOf('*') : undefined) === 0) {
      prefix = '*';
    }
    e.target.value = prefix + e.target.value.replace('*', '');
    this.props.onStarChange({ target: ReactDOM.findDOMNode(this) });
    if (this.props.newUx) return this.props.onChange(e);
    return this.publish(e.target.value);
  },

  onToggle(e) {
    const text = this.get('value') || '';
    if ((text != null ? text.indexOf('*') : undefined) === 0) {
      e.target.value = (text || ' ').substring(1);
    } else {
      e.target.value = `*${text}`;
    }
    this.props.onStarChange({ target: ReactDOM.findDOMNode(this), value: e.target.value });
    if (this.props.newUx) return this.props.onChange(e);
    return this.publish(e.target.value);
  },

  getInputNode() {
    return this._refs.input.current;
  },

  render() {
    let hasStar;
    let text = this.get('value') ?? '';
    if (text.indexOf('*') === 0) {
      hasStar = true;
      text = (text ?? '').substring(1);
    }

    if (this.props.newUx) {
      return (
        <TextField
          {...this.props}
          onChange={({ event }) => this.props.onChange(event)}
          value={text}
          variant="headless"
          className="!p-0 w-full"
          endSlot={
            <i
              className={cx({
                starIcon: true,
                fa: true,
                'fa-star-o': !hasStar,
                'fa-star': hasStar
              })}
              onClick={this.onToggle}
              style={{ width: '36px', height: '20px' }}
            />
          }
        ></TextField>
      );
    }

    let { dataTestId, ...spreadProps } = this.props;

    return (
      <Input
        ref={this._refs.input}
        type="text"
        {...spreadProps}
        className="bz-star-edit"
        value={text}
        onChange={this.onChange}
        onBlur={this.props.onBlur}
        onFocus={this.props.onFocus}
        onKeyDown={this.props.onKeyDown}
        style={this.props.style}
        inputProps={{ 'data-testid': dataTestId }}
        endAdornment={
          <InputAdornment position="end">
            <i
              className={cx({
                starIcon: true,
                fa: true,
                'fa-star-o': !hasStar,
                'fa-star': hasStar
              })}
              onClick={this.onToggle}
              style={{ width: '36px', height: '20px' }}
            />
          </InputAdornment>
        }
      />
    );
  }
});

export default refs('input')(StarInput);
